<svg xmlns="http://www.w3.org/2000/svg" width="29" height="24" viewBox="0 0 29 24" fill="none"><path d="M0 24V15L12 12L0 9V0L28.5 12L0 24Z" fill="currentColor"/></svg>
